// A TRIMMED Monaco build: the editor core + only the JSON language (for the
// `.args.json` companions). Seal itself is a custom Monarch language with no
// worker. Importing `monaco-editor` (the default) bundles ~80 built-in
// languages (abap, pgsql, solidity, …), ~4 MB. Importing only editor.api +
// the json contribution cuts that to a fraction.

import * as monaco from "monaco-editor/esm/vs/editor/editor.api";
import "monaco-editor/esm/vs/language/json/monaco.contribution";

import EditorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";
import JsonWorker from "monaco-editor/esm/vs/language/json/json.worker?worker";

(self as unknown as { MonacoEnvironment?: monaco.Environment }).MonacoEnvironment = {
  getWorker(_workerId: string, label: string): Worker {
    if (label === "json") return new JsonWorker();
    return new EditorWorker();
  },
};

export default monaco;
